import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "./styles/global.css";

// We inject server-rendered body content into #root for crawlers + link
// previews (see src/server/ssr.ts). On a real user's device, wipe it
// explicitly before React mounts so there's no one-frame flash of the
// fallback HTML before hydration takes over.
const container = document.getElementById("root")!;
while (container.firstChild) container.removeChild(container.firstChild);

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
